/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import { EffectCoverflow } from 'swiper/modules'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function CoverflowPreview({ srcs, setSrcs }) {
  const [key, setKey] = useState(0)
  const swiperRef = useRef(null)
  const validImages = srcs.filter(
    (src) =>
      src.file instanceof Blob ||
      src.file instanceof File ||
      (typeof src.file === 'string' && src.file.startsWith('blob:'))
  )

  useEffect(() => {
    if (srcs.length > 0) {
      setKey((prevKey) => prevKey + 1)
    }
  }, [srcs.length])

  const handleWheel = (e) => {
    if (swiperRef.current) {
      if (e.deltaY > 0) {
        swiperRef.current.swiper.slideNext()
      } else {
        swiperRef.current.swiper.slidePrev()
      }
    }
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <Swiper
        ref={swiperRef}
        effect="coverflow"
        grabCursor
        centeredSlides
        spaceBetween={0}
        loop
        observeParents
        observer
        resizeObserver={false}
        speed={800}
        watchSlidesProgress
        slidesPerView="3"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 500,
          disableOnInteraction: false,
        }}
        modules={[EffectCoverflow]}
        onSlideChangeTransitionEnd={(swiper) => {
          swiper.update()
        }}
        className="custom-swiper"
      >
        {validImages.map((src, idx) => (
          <SwiperSlide key={idx} className="custom-swiper-slide">
            <img
              className="custom-swiper-img"
              src={
                typeof src.file === 'string'
                  ? src.file
                  : URL.createObjectURL(src.file)
              }
              alt={src.label || 'Image'}
            />
            <CIIcon />
          </SwiperSlide>
        ))}
      </Swiper>
      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

CoverflowPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  setSrcs: PropTypes.func.isRequired,
}

export default CoverflowPreview
